// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2nBQy","title":"card_title__2avoM","inActive":"card_inActive___Fl6k"};